import { FC } from 'react';

import { FaWhatsapp } from 'react-icons/fa';

import { FloatingLink } from './styles';

const WHATSAPP_URL = 'https://wa.me/5511958425328';

export const WhatsappFloatingButton: FC = () => {
  return (
    <FloatingLink
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp"
      title="Falar no WhatsApp"
    >
      <FaWhatsapp size={30} />
    </FloatingLink>
  );
};
